import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SubscriptionsKindIdSelect = ({register, errors, translations, links, countryCode}) => {
  const [subscriptionKinds, setSubscriptionKinds] = useState([]);

  useEffect(() => {
    axios.request({
      url: '/api/panel/settings/subscriptions/kinds',
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      },
      params: { country_code: countryCode }
    })
    .then((response) => {
      setSubscriptionKinds(response.data);
    });
  }, [countryCode]);

  return (
    <div>
      <div className="form__group form__group--text text-center">
        <h2 className="form__title">{translations.firstHeader}</h2>
      </div>
      <div className="input-group form__group form__group--text text-center col-6 col-sm-6 mx-auto">
        <p>{translations.note}</p>
      </div>
      {
        subscriptionKinds.map((subscription_kind, index) => {
          return <div key={index} className="radiobutton form__group input-group form__group col-10 col-sm-9 mx-auto">
            <input ref={register} value={subscription_kind['id']} id={"form_data_subscription_kind_id_" + index} name="form_data[subscription_kind_id]" type="radio" />
            <label htmlFor={"form_data_subscription_kind_id_" + index}>{subscription_kind['description']}</label>
          </div>
        })
      }
      <div className="input-group col-10 col-sm-9 mx-auto px-0 px-sm-4 mb-4 text-right">
        <a href={links.whatIsIncludedUrl} className="second-primary">{translations.whatIsIncluded}</a>
      </div>
    </div>
  );
};

export default SubscriptionsKindIdSelect;
